import './Reminders.scss';
import * as React from 'react';
import { actionCreator as authActions } from '../../common/Auth0/store/actions/creators';
import { IState as IReminderState } from '../../common/store/reminders/state';
import { IActions as IReminderActions, actionCreator as remindersActions } from '../../common/store/reminders/actions/creators';
import { IApplicationState } from '../../store/ApplicationState';
import { Grid, CircularProgress, StyledComponentProps, withStyles } from '@material-ui/core';
import { connect } from 'react-redux';
import { styles } from './styles';
import Paper from '../../ui-components/Containers/Paper';
import { WithMediaQuery, IMediaQueryProps } from '../../layout/withMediaQuery';
import { reminder, emptyReminder } from '../../model/reminder';
import { ReminderList } from './List/ReminderList';
import { Filters } from './Filters/Filters';
import ReminderDialog from './List/ReminderDialog';

interface IProps extends IReminderActions, IReminderState, IMediaQueryProps, StyledComponentProps {
    // navigateTo: (path: string) => void;
    // match: {
    //     params: {
    //         id: string
    //     }
    // }
}
interface IState {
    fullnameOrEmail: string;
    openReminderDialog: boolean;
    selectedReminder: reminder;
}

// const DefaultRowsPerPage = 10;

class CompContainer extends React.Component<IProps, IState>
{
    state = {
        fullnameOrEmail: "",
        openReminderDialog: false,
        selectedReminder: emptyReminder(),
    };

    componentDidMount() {
        // const { id } = this.props.match.params;
        this.props.loadReminders('');
    }

    handleSelection = (_id: string) => {
        console.log("-------------------------------------");
        console.log(_id);
        // this.setState({ contactsCollapsed: this.props.smallScreen ? true : this.state.contactsCollapsed });
        // this.props.loadTrainer(_id);
        var r = this.props.reminders.find(rr => rr._id === _id);
        // console.log(r);
        this.setState({
            selectedReminder: r,
            openReminderDialog: true
        })
    }

    private handleChangeFullnameOrEmail = (val: string) => {
        this.setState({ fullnameOrEmail: val });
    }

    private search = (sub?: string) => {
        console.log("--------------------------------------");
        console.log(sub);
        if (sub !== undefined) {
            this.props.loadReminders(sub);
        }
        else {
            this.props.loadReminders('');
        }
    }

    cancelDialog = () => {
        this.setState({
            openReminderDialog: false
        });
    }
    saveReminderX = (r: reminder) => {
        console.info("--------------------------------------------")
        console.info(r);
        if (r.expiresOn === undefined) {
            alert("Impostare una data di scadenza del promemoria");
            return;
        }

        if (r._id === undefined) {
            this.props.addReminder(r);
        } else {
            this.props.saveReminder(r);
        }
        this.setState({openReminderDialog: false });
        // this.props.loadReminders('');
    }
    doneReminder = (r: reminder, done: boolean) => {
        r.done = done;
        this.props.saveReminder(r);
        this.setState({openReminderDialog: false });
        // this.props.loadReminders('');
    }
    onNewReminderClick = () => {
        // let open: boolean = this.state.openReminderDialog;
        // if (open) {
        //     open = false;
        //     this.props.loadReminders('');
        // } else {
        //     open = true;
        // }
        this.setState({
            selectedReminder: emptyReminder(),
            openReminderDialog: true
        })
    }

    render() {
        // const { id } = this.props.match.params;
        // const { classes } = this.props;
        return (
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <Filters
                        handleChangeFullnameOrEmail={this.handleChangeFullnameOrEmail}
                        search={this.search}
                        fullnameOrEmail={this.state.fullnameOrEmail}
                        classes={this.props.classes}
                        new={this.onNewReminderClick}
                        loading={this.props.isLoadingReminders}
                    />
                </Grid>
                <Grid item xs={12} sm={12}>
                    <Paper title='Elenco'
                        collapsed={this.props.smallScreen ? true : false} // true --> this.state.contactsCollapsed 
                        fullHeight={false}
                        contentContainerStyle={this.props.smallScreen ? { minHeight: '300px' } : { heigth: 'calc(100% - 1px)' }}>
                        <Grid container justify={"center"}>
                            {this.props.isLoadingReminders ? 
                                <Grid item xs={12} style={{ display: 'flex' }}>
                                    <CircularProgress size={80} />
                                </Grid>
                                :
                                <>
                                <Grid item xs={12} >
                                    <ReminderList
                                        classes={this.props.classes}
                                        reminderList={this.props.reminders ?? []}
                                        selected={null}
                                        doneReminder={this.doneReminder}
                                        onReminderClick={this.handleSelection}
                                        // navigateTo={this.props.navigateTo}
                                    />
                                </Grid>
                                </>
                            }
                        </Grid>
                    </Paper>
                </Grid>
                <ReminderDialog
                    classes={this.props.classes}
                    reminder={this.state.selectedReminder}
                    canChangeContact={this.state.selectedReminder._id === undefined}
                    onCancel={this.cancelDialog}
                    onSave={this.saveReminderX}
                    open={this.state.openReminderDialog}
                />
            </Grid>
        );
    }
}

const mapStateToProps = (state: IApplicationState, ownP) => ({
    ...state.reminders,
    ...ownP
})

const mapDispatchToProps = (dispatch: any) => ({
    ...remindersActions(dispatch),
    navigateTo: authActions(dispatch).navigateTo
})

export const Reminders = connect(mapStateToProps, mapDispatchToProps)(WithMediaQuery(withStyles(styles)(CompContainer)));